import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EntertainmentService {
  // Signal to track dropdown state
  isDropdownOpen = signal(false);

  toggleDropdown(): void {
    this.isDropdownOpen.update(current => !current);
  }

  closeDropdown(): void {
    this.isDropdownOpen.set(false);
  }

  openDropdown(): void {
    this.isDropdownOpen.set(true);
  }
}